import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Form, Frequency } from '@vendasta/galaxy/frequency';
import { PricingRule } from '@vendasta/marketplace-apps';
import { convertCentsToDollars } from '@vendasta/shared';

@Component({
  selector: 'billing-ui-stairsteps-modal',
  templateUrl: 'stairstep-dialog.component.html',
  styleUrls: ['./stairstep-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StairstepDialogComponent {
  Form = Form;
  stairsteps: Map<string, PricingRule>;
  currencyCode = 'USD';
  frequency: Frequency;
  freeLabel: string;

  constructor(@Inject(MAT_DIALOG_DATA) data) {
    this.stairsteps = data.stairsteps;
    this.currencyCode = data.currencyCode;
    this.frequency = data.frequency;
    this.freeLabel = data.freeLabel;
  }

  centsToDollars(value: number): number {
    return convertCentsToDollars(value);
  }

  noSortOrder() {
    return 0;
  }
}
